const arrayUtils = {
  removeDuplicates: <T>(initialArray: Array<T>, prop: keyof T): Array<T> => {
    return initialArray.filter((obj, pos, arr) => {
      return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  },
};

export default arrayUtils;
